import { type AppNode, type ImageNodeData } from '../types';

export function getImageNodeData(node: AppNode): ImageNodeData | undefined {
  if (node.type !== 'image') {
    return undefined;
  }

  const { data } = node;

  if (!data.type || data.fileName === undefined || !data.source) {
    return undefined;
  }

  if (!data.media) {
    return undefined;
  }

  return {
    assetId: data.assetId,
    fileName: data.fileName,
    media: data.media,
    prompt: data.prompt,
    smartResizeFormatId: data.smartResizeFormatId,
    source: data.source,
    type: data.type,
    versionId: data.versionId,
  };
}
